<template>
  <div>
    <Table ref="table" :row-class-name="onRowColor" :columns="columns" :data="list">
      <template slot-scope="{ row }" slot="data_name">
        {{ row.data_name }}<br/>
        {{ row.data_phone }}
      </template>
      
      <template slot-scope="{ row }" slot="weight">
        {{ row.weight }} <Divider type="vertical" /> <span v-if="row.add_weight">{{ row.add_weight }}</span> <Divider type="vertical" /> <a>{{ parseFloat(row.add_weight) + parseFloat(row.weight) }}</a>
      </template>
      
      <template slot-scope="{ row }" slot="money">
        <a>{{ row.money | money }}</a>
      </template>
      
      <template slot-scope="{ row }" slot="take">
        <Tag type="border" :color="row.take ? 'blue' : 'default'">{{ $t('name.cex_order.take_text')[row.take] }}</Tag>
      </template>

      <template slot-scope="{ row }" slot="status">
        <Badge :status="!row.status ? 'processing' : (row.status == 1 ? 'success' : 'error')" :text="$t('name.cex_order.status_text')[row.status]" />
      </template>
      
      <template slot-scope="{ row }" slot="created_at">
        <Time :time="row.created_at * 1000" type="datetime" />
      </template>

      <template slot-scope="{ row }" slot="action">
        <Dropdown trigger="click" @on-click="name => onActive(name, row)">
          <a href="javascript:void(0)">
            {{ $t('name.more') }}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-if="!row.status" name="no">{{ $t('name.cex_order.active_no') }}</DropdownItem>
            <DropdownItem v-if="row.pdf" name="pdf">{{ $t('name.cex_order.pdf') }}</DropdownItem>
            <DropdownItem name="data">{{ $t('name.cex_order.data') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
    </Table>
    <Modal v-model="json.model" :title="$t('name.cex_order.data')" fullscreen footer-hide>
      <pre>{{ json.data }}</pre>
    </Modal>
  </div>
</template>
<script>
import { no } from '@/api/cex_order';
import Row from './row'
import { timeToDate, tableExcel } from '@/tools/utlis'

export default {
  props: {
    list: Array,
  },
  data() {
    return {
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(Row, {
              props: {
                row: params.row
              }
            })
          }
        },
        {
          title: "ID",
          key: "id",
          width: 100
        },
        {
          title: this.$t("name.cex_order.name"),
          key: "name",
          width: 300
        },
        {
          title: this.$t("name.cex_order.waybill"),
          key: "waybill",
          width: 180,
        },
        {
          title: this.$t("name.cex_order.weight") + '/' + this.$t("name.cex_order.add_weight") + '/' + this.$t("name.cex_order.total_weight"),
          slot: 'weight',
          align: 'center',
        },
        {
          title: this.$t("name.cex_order.money"),
          slot: 'money',
          align: 'center',
        },
        {
          title: this.$t("name.cex_order.take"),
          slot: 'take',
          align: 'center',
          width: 120,
        },
        {
          title: this.$t("name.cex_order.status"),
          slot: 'status',
          align: 'center',
          width: 140,
        },
        {
          title: this.$t("name.cex_order.created_at"),
          slot: 'created_at',
          align: 'center',
          width: 180,
        },
        {
          title: this.$t("name.active"),
          slot: 'action',
          width: 120,
          fixed: 'right'
        },
      ],
      excelColumns: [
        {
          title: this.$t("name.cex_order.number"),
          key: "number"
        },
        {
          title: this.$t("name.cex_order.name"),
          key: "name"
        },
        {
          title: this.$t("name.cex_order.waybill"),
          key: "waybill",
          excel: row => {
            row.waybill = !row.waybill ? '' : row.waybill + "\t"
            return row
          }
        },
        {
          title: this.$t("name.cex_order.data_name"),
          key: 'data_name',
        },
        {
          title: this.$t("name.cex_order.data_phone"),
          key: 'data_phone',
        },
        {
          title: this.$t("name.cex_order.count"),
          key: 'count',
        },
        {
          title: this.$t("name.cex_order.weight"),
          key: 'weight',
        },
        {
          title: this.$t("name.cex_order.add_weight"),
          key: 'add_weight'
        },
        {
          title: this.$t("name.cex_order.price"),
          key: 'price'
        },
        {
          title: this.$t("name.cex_order.add_price"),
          key: 'add_price'
        },
        {
          title: this.$t("name.cex_order.collect"),
          key: 'collect'
        },
        {
          title: this.$t("name.cex_order.cost"),
          key: 'collect_cost'
        },
        {
          title: this.$t("name.cex_order.insure"),
          key: 'insure'
        },
        {
          title: this.$t("name.cex_order.cost"),
          key: 'insure_cost'
        },
        {
          title: this.$t("name.cex_order.money"),
          key: 'money',
        },
        {
          title: this.$t("name.cex_order.created_at"),
          key: 'created_at',
          excel: row => {
            row.created_at = timeToDate(row.created_at)
            return row
          }
        }
      ],
      json: {
        model: false,
        data: ''
      }
    };
  },
  methods: {
    onRowColor(data) {
      if(data.track_breakdown) {
        return 'row-error'
      }
    },
    onActive(name, row) {
      switch (name) {
        case 'no':
          return this.onNo(row.id)
        case 'data':
          return this.onData(row.data)
        case 'pdf':
          return window.open(row.pdf, '_blank')
      }
    },
    onNo(id) {
      this.$Modal.confirm({
        title: this.$t('name.cex_order.active_no'),
        content: this.$t('name.cex_order.active_no_message'),
        onOk: () => {
          no(id).then(res => {
            this.$emit('get')
            this.$Message.success(this.$t('message.' + res.message))
          }).catch(res => {
            this.$Message.error(this.$t('message.' + res.message))
          })
        }
      });
    },
    onData(data) {
      this.json.model = true
      this.json.data = JSON.stringify(data, null, 4)
    },
    excel(data) {
      tableExcel(this.$refs.table, this.excelColumns, data) 
    }
  }
};
</script>
<style lang="less">
  @import '@/style/app.less';

  .ivu-table .row-error td{
    background-color: #ffcdcd;
  }
</style>